class ChoiceDateTimeForm {
    constructor(element) {
        this.element = element;
        this.form = $(element).closest('.js-appointment-choice-date-time-form');
        this.timeListElement = $(this.form).find('.js-appointment-choice-date-time-list');
        this.timeList = new TimeList(this.timeListElement);
        this.preloader = new Preloader(this.form);

        $(this.element).on('changeDate', (e) => {
            const dateString = e.detail.date.toLocaleDateString('ru-RU');
            this.form.find('.js-appointment-datepicker-input').val(dateString);
            this.fillTimeList(dateString);
        });
    }

    fillTimeList(date) {
        this.fetchTime(date)
            .then((response) => {
                this.preloader.hidePreloader();
                if (response[0].ok) {
                    $(this.element).trigger('date:before-fill-time-list');

                    this.timeList.fillTimeList(response)

                    $(this.element).trigger('date:fetch-success');
                    return;
                }
                $(this.element).trigger('date:fetch-error', {
                    error: response[1]
                });
            })
            .fail(() => {
                $(this.element).trigger('date:fetch-error', {
                    error: 'Произошла ошибка, повторите попытку позже'
                });
            });
    }

    fetchTime(date) {
        this.preloader.showPreloader();
        const queryParams = getQueryParams()
        const ajaxUrl = getAttr(this.element, 'data-ajax-url')
        return $.ajax({
            type: 'GET',
            data: { date: date, ...queryParams },
            dataType: 'json',
            url: ajaxUrl
        });
    }
}

$('.js-datepicker-choice-date-time').each((i, element) => {
    new ChoiceDateTimeForm(element);
});
